import { render, staticRenderFns } from "./Surveys.vue?vue&type=template&id=b2abcf0a&"
import script from "./Surveys.vue?vue&type=script&lang=js&"
export * from "./Surveys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports